module.exports = __webpack_public_path__ + "static/img/Uli-loading-fd-fast.36b589d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading/Uli-loading-fd-fast.gif
// module id = 1280
// module chunks = 5